import { amountToNumber } from '../../../util/shared/vue-global';

export const checkObjPaymentsDiff = (item) => {
  let thereIsADiff = false;
  const {
    initialPenaltyAmt, initialTaxAmt, penaltyAmt, taxAmt, fees, initialFees,
    initialTaxYear, initialTaxId, taxYear, taxId,
  } = item;

  for (let i = 0; i < (fees || []).length; i += 1) {
    const intFees = initialFees && initialFees[i]
      ? initialFees[i].feeAmount : 0;
    if (amountToNumber(fees[i].feeAmount || 0)
        !== amountToNumber(intFees)) {
      thereIsADiff = true;
    }
  }
  if (amountToNumber(initialPenaltyAmt) !== amountToNumber(penaltyAmt)) thereIsADiff = true;
  if (amountToNumber(initialTaxAmt) !== amountToNumber(taxAmt)) thereIsADiff = true;
  if (amountToNumber(initialTaxYear) !== amountToNumber(taxYear)) thereIsADiff = true;
  if (amountToNumber(initialTaxId) !== amountToNumber(taxId)) thereIsADiff = true;
  return thereIsADiff;
};

export const commonVoidFunc = (items) => {
  const selItem = items;
  selItem.amount = 0.00;
  selItem.taxDetails = (selItem.taxDetails || []).map((item) => {
    // void only the unposted and unvoided records
    if (!item.posted && !item.void) {
      const updatedItem = { ...item };
      updatedItem.taxAmt = 0.00;
      updatedItem.penaltyAmt = 0.00;
      updatedItem.total = 0.00;
      updatedItem.void = true;
      updatedItem.tempVariableVoid = true;
      updatedItem.fees = [];
      updatedItem.totalFees = 0.00;
      // 'isItNewVoidedRecord' will allow us to mitigate compare with previous data in backend
      updatedItem.isItNewVoidedRecord = true;
      return updatedItem;
    }
    return item;
  });
  const checkIsEveryRecIsVoidOrNot = (selItem.taxDetails || []).every((ft) => ft.void);
  // only remove payment-details only when every tax-records is voided
  if (checkIsEveryRecIsVoidOrNot) {
    selItem.paymentDetails = (selItem.paymentDetails || []).map((item) => {
      const updatedItem = { ...item };
      updatedItem.amount = 0.00;
      return updatedItem;
    });
  }
  return selItem;
};

export default {};
